export const SESSION_EXPIRED_STORAGE_KEY = 'auth.sessionExpired';
export const SESSION_EXPIRED_RETURN_TO_KEY = 'auth.sessionExpiredReturnTo';
